'use es6';

import BasePatternFactory from '../lib/BasePatternFactory';
import UrlRegex from '../regex/UrlRegex';
import UrlWithProtocolRegex from '../regex/UrlWithProtocolRegex';
import UrlRegexFactory from '../regex/factories/UrlRegexFactory';
import UrlParts from '../regex/parts/UrlParts';

var _makeGlobalUrlRegex = function _makeGlobalUrlRegex() {
  return UrlRegexFactory({
    isGlobal: true,
    search: UrlParts.ungroupedSearch
  });
};

var UrlPattern = BasePatternFactory({
  name: 'Url',
  validator: function validator(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (options && options.requireProtocol) {
      return UrlWithProtocolRegex.test(input);
    }

    return UrlRegex.test(input);
  }
});

UrlPattern.pick = function (input) {
  var GlobalUrlRegex = _makeGlobalUrlRegex();

  var results = [];
  var matchedGroups = GlobalUrlRegex.exec(input);

  while (matchedGroups !== null) {
    var start = matchedGroups.index;
    var end = start + matchedGroups[0].length - 1;
    results.push({
      start: start,
      end: end
    });
    matchedGroups = GlobalUrlRegex.exec(input);
  }

  return results;
};

export default UrlPattern;